import React from 'react';

import { Link } from 'react-router-dom';

const About = () => {
  

  return (
    <main style={styles.main()}>
      <div style={styles.container}>
        {/* Header */}
        <div style={styles.header}>
          <span style={styles.pill}>Our Story</span>
          <h1 style={styles.title}>About Techdave Solutions</h1>
        </div>

        {/* Story Section */}
        <div style={styles.storyGrid}>
          <div style={styles.storyText}>
            <h2 style={styles.storyTitle}>Harare's Trusted Tech Partner</h2>
            <p style={styles.storyP}>
              Techdave Solutions is Harare's premier technology retailer, proudly located at
              B30 Eastgate Market. We specialize in providing quality electronics and technology
              products to individuals, businesses, and organizations across Zimbabwe.
            </p>
            <p style={styles.storyP}>
              With over 500 products in our range and a team passionate about technology,
              we combine competitive pricing with expert knowledge to ensure every customer
              finds the right solution.
            </p>
            <p style={styles.storyP}>
              Whether you need a laptop for work, a PA system for your event, networking
              equipment for your office, or simply a phone accessory — Techdave Solutions
              has you covered.
            </p>
          </div>
          <div style={styles.storyStats()}>
            {[
              { num: '500+', label: 'Products Available' },
              { num: '5★', label: 'Customer Rating' },
              { num: '24/7', label: 'Support Available' },
              { num: '1', label: 'Trusted Location' },
            ].map((s) => (
              <div key={s.label} style={styles.statItem()}>
                <span style={styles.statNum}>{s.num}</span>
                <span style={styles.statLabel}>{s.label}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Values */}
        <div style={styles.valuesSection}>
          <h2 style={styles.valuesTitle}>Our Values</h2>
          <div style={styles.valuesGrid}>
            {[
              { icon: '🎯', title: 'Quality First', desc: 'We only stock genuine, quality-certified products.' },
              { icon: '🤝', title: 'Customer Focus', desc: 'Your satisfaction is our top priority, always.' },
              { icon: '💡', title: 'Expert Knowledge', desc: 'Our team stays up-to-date with the latest tech.' },
              { icon: '🏆', title: 'Integrity', desc: 'Transparent pricing and honest advice, every time.' },
            ].map((v) => (
              <div key={v.title} style={styles.valueCard()}>
                <div style={styles.valueIcon}>{v.icon}</div>
                <h3 style={styles.valueTitle}>{v.title}</h3>
                <p style={styles.valueDesc}>{v.desc}</p>
              </div>
            ))}
          </div>
        </div>

        {/* CTA */}
        <div style={styles.cta}>
          <h2 style={styles.ctaTitle}>Come Visit Us</h2>
          <p style={styles.ctaSub}>B30 Eastgate Market, Harare — Monday to Saturday, 8AM–5PM</p>
          <div style={styles.ctaBtns}>
            <Link to="/shop" style={styles.ctaBtnPrimary}>Browse Products</Link>
            <Link to="/contact" style={styles.ctaBtnOutline}>Contact Us</Link>
          </div>
        </div>
      </div>
    </main>
  );
};

const styles = {
  main: () => ({
    minHeight: '100vh',
    paddingTop: '72px',
    backgroundColor: '#f5f5f5',
    color: '#111111',
  }),
  container: {
    maxWidth: '1100px',
    margin: '0 auto',
    padding: '60px 24px',
    display: 'flex',
    flexDirection: 'column',
    gap: '72px',
  },
  header: {
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '12px',
  },
  pill: {
    background: 'rgba(204,0,0,0.12)',
    border: '1px solid rgba(204,0,0,0.3)',
    color: '#CC0000',
    padding: '6px 16px',
    borderRadius: '100px',
    fontSize: '13px',
    fontWeight: '600',
  },
  title: {
    fontSize: 'clamp(32px, 5vw, 52px)',
    fontWeight: '900',
    letterSpacing: '-0.02em',
    color: '#111111',
  },
  storyGrid: {
    display: 'grid',
    gridTemplateColumns: '1.4fr 1fr',
    gap: '48px',
    alignItems: 'start',
  },
  storyText: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  storyTitle: {
    fontSize: '26px',
    fontWeight: '800',
    color: '#CC0000',
    marginBottom: '4px',
  },
  storyP: {
    fontSize: '16px',
    lineHeight: 1.75,
    color: '#111111',
  },
  storyStats: () => ({
    backgroundColor: '#ffffff',
    borderRadius: '16px',
    padding: '32px',
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '24px',
    border: '1px solid rgba(204,0,0,0.15)',
    boxShadow: '0 4px 24px rgba(204,0,0,0.1)',
  }),
  statItem: () => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    padding: '16px',
    backgroundColor: '#f5f5f5',
    borderRadius: '10px',
    textAlign: 'center',
  }),
  statNum: {
    fontSize: '32px',
    fontWeight: '900',
    color: '#CC0000',
  },
  statLabel: {
    fontSize: '12px',
    fontWeight: '700',
    letterSpacing: '0.06em',
    color: '#111111',
    textTransform: 'uppercase',
  },
  valuesSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: '32px',
  },
  valuesTitle: {
    fontSize: '28px',
    fontWeight: '800',
    textAlign: 'center',
    color: '#111111',
  },
  valuesGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
    gap: '20px',
  },
  valueCard: () => ({
    backgroundColor: '#ffffff',
    borderRadius: '14px',
    padding: '28px',
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    border: '1px solid rgba(0,0,0,0.06)',
  }),
  valueIcon: {
    fontSize: '32px',
    width: '52px',
    height: '52px',
    borderRadius: '12px',
    backgroundColor: 'rgba(204,0,0,0.1)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  valueTitle: {
    fontSize: '17px',
    fontWeight: '700',
    color: '#CC0000',
  },
  valueDesc: {
    fontSize: '14px',
    lineHeight: 1.6,
    color: '#111111',
  },
  cta: {
    background: 'linear-gradient(135deg, #CC0000 0%, #990000 100%)',
    borderRadius: '20px',
    padding: '56px 40px',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '16px',
    boxShadow: '0 8px 40px rgba(204,0,0,0.3)',
  },
  ctaTitle: {
    fontSize: '36px',
    fontWeight: '900',
    color: '#ffffff',
  },
  ctaSub: {
    fontSize: '16px',
    color: 'rgba(255,255,255,0.85)',
  },
  ctaBtns: {
    display: 'flex',
    gap: '16px',
    marginTop: '8px',
    flexWrap: 'wrap',
    justifyContent: 'center',
  },
  ctaBtnPrimary: {
    padding: '14px 32px',
    backgroundColor: '#ffffff',
    color: '#CC0000',
    borderRadius: '10px',
    fontWeight: '800',
    fontSize: '15px',
    textDecoration: 'none',
  },
  ctaBtnOutline: {
    padding: '14px 32px',
    backgroundColor: 'transparent',
    color: '#ffffff',
    borderRadius: '10px',
    fontWeight: '700',
    fontSize: '15px',
    textDecoration: 'none',
    border: '2px solid rgba(255,255,255,0.5)',
  },
};

export default About;